<template>
  <div class="email-template">
    <div class="row">
      <div class="col-sm-6">
        <h4>{{ emailTemplate.name }}</h4>
        <p><strong>Email Type: </strong> {{ emailTemplate.emailType }}</p>
      </div>
      <div class="col-sm-6">
        <p><strong>BCC: </strong><br/>
          <template v-for="email in emailTemplate.bccAddress">
            {{ email }}
          </template>
        </p>
        <p><strong>CC: </strong><br/>
          <template v-for="email in emailTemplate.ccAddress">
            {{ email }}
          </template>
        </p>
      </div>
    </div>
    <div class="toolbar text-right">
      <router-link class="btn btn-default"
      :to="{ path: `/membership/emails/edit/${emailTemplate.uuid}` }">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
      <button class="btn btn-primary" type="button" @click="preview()">
        <span class="fa fa-eye"></span>
        &nbsp;Preview
      </button>
    </div>
  </div>
</template>

<script>
import Api from '@/vuex/api'
import { OPEN_MODAL } from '@/vuex/types'
export default {
  name: 'EmailTemplate',
  props: {
    object: {
      type: Object
    }
  },
  data () {
    return {
      emailTemplate: {
        name: '',
        slug: '',
        ccAddress: '',
        bccAddress: '',
        emailType: ''
      }
    }
  },
  mounted () {
    this.emailTemplate = this.object
  },
  methods: {
    async preview () {
      let api = new Api()
      let html = await api.compileEmailTemplate(this.emailTemplate.content)
      let previewModal = {
        title: 'Email Template Preview',
        html
      }
      this.$store.dispatch(OPEN_MODAL, previewModal)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/EmailTemplate.vue